import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Customer } from '../models/customer.model';
import { AuthService } from './auth.service';
import { ConfigurationService } from './configuration.service';

@Injectable()
export class CustomersService {
    private _authService: AuthService;

    constructor(private http: HttpClient, private injector: Injector) { }

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }

    createUpdate(customer: Customer) {
        return this.http.post('api/Customer', customer, this.getAuthHeader(true));
    }

    get() {
        return this.http.get('api/Customer', this.getAuthHeader(true));
    }

    getCount() {
        return this.http.get('api/Customer/GetCount', this.getAuthHeader(true));
    }

    getById(id: number) {
        return this.http.get(`api/Customer/${id}`, this.getAuthHeader(true));
    }

    getCustomerById(id: number) {
        return this.http.get(`api/Customer/GetById/${id}`, this.getAuthHeader(true));
    }

    getLinkedGroup(id: number) {
        return this.http.get(`api/Customer/GetLinkedGroup/${id}`, this.getAuthHeader(true));
    }

    delete(id: number) {
        return this.http.get(`api/Customer/Delete/${id}`, this.getAuthHeader(true));
    }

    deleteCustomerFromGroup(customerId: number, linkedCustomerId: number) {
        return this.http.get(`api/Customer/DeleteFromGroup/${customerId}/${linkedCustomerId}`, this.getAuthHeader(true));
    }

    public getAuthHeader(includeJsonContentType?: boolean) {
        let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", 'application/json');
        headers.append("App-Version", ConfigurationService.appVersion);

        const options = {
            headers: headers
        };
        return options;
    }

    exportExcel(ids: string) {
        return this.http.post(`/api/Customer/ExportExcel`, { ids: ids }, {
            responseType: 'blob',
            headers: new HttpHeaders()
                .append('Authorization', 'Bearer ' + this.authService.accessToken)
                .append('Content-Type', 'application/json')
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/customers.service.ts